export default "__VITE_ASSET__Byhomlft__"